module.exports = __webpack_public_path__ + "img/ai-3.87e1c54.png";